import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  LinearProgress,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Container,
  Grid,
  Box,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTimeRecordService } from '../../../../../hooks/services/useTimeRecordService';
import { useCalculationDate } from '../../../../../hooks/services/useCalculationDate';
import { useWizardRequest } from '../../../../../hooks/services/useWizardRequest';
import IWizardStep from '../../../../../interfaces/IWizardStep';
import ICalculationDate from '../../../../../interfaces/ICalculationDate';
import moment from 'moment';
import 'moment/locale/pt-br';

interface TimeRecord {
  id: string;
  date: string;
  timeRecord: string;
  origin: number;
  action: string;
  status: string;
  points: string;
}

interface TimeRecordFormProps extends IWizardStep { }

const TimeRecordForm = (props: TimeRecordFormProps) => {

  const [loading, setLoading] = useState(false);
  const [days, setDays] = useState<Record<string, TimeRecord[]>>({});
  const [calculationsDates, setCalculationsDates] = useState<Record<string, ICalculationDate>>({});
  const [selectedDateId, setSelectedDateId] = useState<string>('');

  const request = useTimeRecordService();
  const requestCalculationDate = useCalculationDate();
  const requestWizard = useWizardRequest();

  moment.locale('pt-br');

  const rowsInDays = (rows: TimeRecord[]) => {
    const agrupado = rows.reduce((acc, item) => {
      const day = moment(item.date).format('YYYY-MM-DD');
      acc[day] = [...(acc[day] || []), item];
      return acc;
    }, {} as Record<string, TimeRecord[]>);
    setDays(agrupado);
  };

  const findByCalculationDate = async (calculationDate: ICalculationDate, employeeId: number) => {
    const { initialDate, finalDate } = calculationDate
    setLoading(true);
    const dateInitial = moment(initialDate).format('YYYY-MM-DD')
    const DateFinal = moment(finalDate).format('YYYY-MM-DD')

    const employee = await requestWizard.listEmployeeById(employeeId);
    await request
      .listByEmployeeAndDateTimeRecords(String(dateInitial), String(DateFinal), employee.id!)
      .then((resul) => {
        setLoading(false);
        rowsInDays(resul);
      });
  };

  const findCalculationDates = async () => {
    setLoading(true);
    const employee = await requestWizard.listEmployeeById(props.medicalCertificate.employeeId);
    const results = await requestCalculationDate.listWithSearch(employee.id!, 6, 'ASC');
    setCalculationsDates(results);
    setLoading(false);
  };

  const run = async () => {
    if (!props.medicalCertificate) return;

    await findCalculationDates();

  };

  useEffect(() => {
    if (selectedDateId && calculationsDates[selectedDateId]) {

      findByCalculationDate(calculationsDates[selectedDateId], props.medicalCertificate.employeeId);
    } else {
      run();
    }
  }, [selectedDateId]);

  useEffect(() => {
    const entries = Object.keys(calculationsDates);
    if (entries.length > 0 && !selectedDateId) {
      setSelectedDateId(entries[0]);
    }
  }, [calculationsDates])
  return (
    <Container
      maxWidth={false}
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
        padding: '20px',
        boxSizing: 'border-box',
      }}
    >
      <Grid container spacing={2} marginTop={10}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="select-integration">Data de Cálculo</InputLabel>
            <Select
              labelId="select-integration"
              label="Data de Cálculo"
              value={selectedDateId}
              onChange={(e) => setSelectedDateId(e.target.value)}
              sx={{ height: '40px' }}
            >
              {Object.entries(calculationsDates).map(([id, dateRange]) => (
                <MenuItem key={id} value={id}>
                  {moment(dateRange.initialDate).format('DD/MM/YYYY')} - {moment(dateRange.finalDate).format('DD/MM/YYYY')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {loading && <LinearProgress sx={{ marginTop: 2 }} />}

      <Box sx={{ flexGrow: 1, overflow: 'auto', marginTop: 2 }}>
        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell>Dias</TableCell>
              <TableCell>Horário</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(days).map(([date, records]) => {
              const timeFormated = records
                .map((record) => moment(record.points).format('HH:mm'))
                .join(' - ');

              return (
                <TableRow key={date}>
                  <TableCell>{moment(date).format('DD/MM/YYYY')}</TableCell>
                  <TableCell>{timeFormated}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Container>
  );

};

export default TimeRecordForm;
